import { type Brand } from '@/consts/brands';
import { ALL_STATES } from '@/consts/states';
import { updateRegistrationEligibility } from '@/services/eligibilityService/actions';
import { type RegistrationEligibilityDataType } from '@/types/eligibility/eligibility';

import { FORM_CONFIG } from '../config';

import { logEligibilityFailure } from './index';

export interface StateOption {
  disabled: boolean;
  label: string;
  value: string;
}

export const isBirthdateValid = (birthdate?: string) => {
  if (!birthdate) {
    return false;
  }

  if (birthdate.trim().length !== 10) {
    return false;
  }

  const birthdateParts = birthdate.split('/');

  const birthdateDate = new Date(
    `${birthdateParts[2]}-${birthdateParts[0]}-${birthdateParts[1]}`,
  );

  const today = new Date();

  return (
    birthdateDate <= today &&
    today.getFullYear() - birthdateDate.getFullYear() <= 100
  );
};

export const getStateOptions = () => {
  const stateOptions: StateOption[] = [];

  stateOptions.push({
    disabled: true,
    label: FORM_CONFIG.state.label,
    value: FORM_CONFIG.state.defaultValue,
  });

  Object.entries(ALL_STATES).forEach(([value, label]) => {
    stateOptions.push({
      disabled: false,
      label,
      value,
    });
  });

  return stateOptions;
};

export const updateEligibilityData = async (
  brand: Brand,
  data: Partial<RegistrationEligibilityDataType>,
) => {
  try {
    await updateRegistrationEligibility(brand, data);
  } catch (error: any) {
    logEligibilityFailure(error);
  }
};

export const getSubmitButtonText = (
  btnNextText?: string,
  withTosCheckbox?: boolean,
) => {
  if (btnNextText) {
    return btnNextText;
  } else if (withTosCheckbox === false) {
    return FORM_CONFIG.submitButtonText.withoutTosCheckout;
  }

  return FORM_CONFIG.submitButtonText.default;
};
